// Tab-based access control configuration - only "stamatis" has super admin access
export const AVAILABLE_TABS = [
  'dashboard',
  'clients', 
  'people',
  'proposals',
  'projects',
  'activities',
  'xero-lite',
  'users',
  'initiatives',
  'wisdrop',
  'settings'
] as const;

// SECURITY: Removed hardcoded super admin bypass - use database roles instead
// Super admin access is now managed through the user_roles table in the database
export const isSuperAdmin = (user: { role?: string; email?: string; first_name?: string } | null | undefined): boolean => {
  // This function is deprecated - use database role checks instead
  return false;
};

// Legacy role-based permissions - kept for backward compatibility
export const ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager', 
  USER: 'user',
  ACCOUNTING: 'accounting',
  FINANCE: 'finance'
} as const;

export const PERMISSIONS = {
  // Dashboard access
  VIEW_DASHBOARD: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
  VIEW_ANALYTICS: [ROLES.ADMIN, ROLES.MANAGER],

  // Client management
  VIEW_CLIENTS: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
  CREATE_CLIENTS: [ROLES.ADMIN, ROLES.MANAGER],
  EDIT_CLIENTS: [ROLES.ADMIN, ROLES.MANAGER],
  DELETE_CLIENTS: [ROLES.ADMIN],

  // Proposal management
  VIEW_PROPOSALS: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
  CREATE_PROPOSALS: [ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
  EDIT_PROPOSALS: [ROLES.ADMIN, ROLES.MANAGER],
  DELETE_PROPOSALS: [ROLES.ADMIN, ROLES.MANAGER],

  // Invoice management
  VIEW_INVOICES: [ROLES.ADMIN, ROLES.MANAGER, ROLES.ACCOUNTING, ROLES.FINANCE],
  CREATE_INVOICES: [ROLES.ADMIN, ROLES.ACCOUNTING, ROLES.FINANCE],
  EDIT_INVOICES: [ROLES.ADMIN, ROLES.ACCOUNTING, ROLES.FINANCE],
  DELETE_INVOICES: [ROLES.ADMIN, ROLES.ACCOUNTING],

  // User management
  VIEW_USERS: [ROLES.ADMIN],
  CREATE_USERS: [ROLES.ADMIN],
  EDIT_USERS: [ROLES.ADMIN],
  DELETE_USERS: [ROLES.ADMIN],

  // Settings
  VIEW_SETTINGS: [ROLES.ADMIN, ROLES.MANAGER],
  EDIT_SETTINGS: [ROLES.ADMIN],
} as const;

export type Role = typeof ROLES[keyof typeof ROLES];
export type Permission = keyof typeof PERMISSIONS;
export type TabName = typeof AVAILABLE_TABS[number];